var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBadgeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 39.9777,
    height: 23.9732,
    viewBox: "0 0 39.9777 23.9732",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M19.9888 0L21.1911 1.22412L22.6546 0.10707L23.5742 1.41641L25.2727 0.42637L25.8933 1.79757L27.7966 0.952201L28.107 2.3608L30.1812 1.67518L30.1759 3.09603L32.3838 2.58241L32.063 3.99016L34.3653 3.65769L33.7346 5.02722L36.0902 4.88184L35.1609 6.18871L37.5278 6.23302L36.3165 7.4539L38.6524 7.68711L37.1807 8.80022L39.444 9.21816L37.7381 10.2036L39.8884 10.7989L37.9788 11.6391L39.9777 12.401L37.8984 13.081L39.7102 13.996L37.4985 14.5037L39.0909 15.5553L36.7861 15.8816L38.1306 17.0512L35.7739 17.1903L36.8467 18.457L34.4801 18.4063L35.2619 19.7475L32.9277 19.5081L33.4045 20.8998L31.1443 20.4758L31.3078 21.8933L29.1619 21.2923L29.009 22.7102L27.0158 21.943L26.5493 23.336L24.7443 22.4163L23.9725 23.7595L22.388 22.7036L21.3247 23.9732L19.9888 22.8L18.653 23.9732L17.5897 22.7036L16.0051 23.7595L15.2333 22.4163L13.4283 23.336L12.9618 21.943L10.9686 22.7102L10.8157 21.2923L8.66989 21.8933L8.83333 20.4758L6.57314 20.8998L7.05 19.5081L4.71579 19.7475L5.49757 18.4063L3.13099 18.457L4.20373 17.1903L1.84701 17.0512L3.19158 15.8816L0.88678 15.5553L2.47918 14.5037L0.267426 13.996L2.07923 13.081L0 12.401L1.99888 11.6391L0.0892735 10.7989L2.23957 10.2036L0.533657 9.21816L2.79699 8.80022L1.32522 7.68711L3.66119 7.4539L2.44983 6.23302L4.81677 6.18871L3.88743 4.88184L6.24309 5.02722L5.61236 3.65769L7.91471 3.99016L7.59383 2.58241L9.80178 3.09603L9.7965 1.67518L11.8706 2.3608L12.181 0.952201L14.0844 1.79757L14.7049 0.42637L16.4035 1.41641L17.3231 0.10707L18.7866 1.22412L19.9888 0Z",
    fill: "#FCD34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadgeStar);
export default __webpack_public_path__ + "static/media/newBadgeStar.b9c8e5ae359937807dac44f15b6f4d6f.svg";
export { ForwardRef as ReactComponent };